module.exports = __webpack_public_path__ + "img/20190718162710966.47ffde88.png";